<template>

<simplebar ref="simplebar" force-visible>

	<slot></slot>

</simplebar>

</template>

<script>
import 'simplebar-core/dist/simplebar.css'
import simplebar from 'simplebar-vue'

export default {
  props: ['scrollendOffset', 'initialScroll', 'trackScroll', 'eventName'],

  components: {
    simplebar
  },

  data: function () {
    return {
      onScrollBound: null,
      onScrollTopBound: null
    }
  },

  mounted: function () {
    // Bind once so removeEventListener works
    this.onScrollBound = this.onScroll.bind(this)
    this.onScrollTopBound = this.onScrollTop.bind(this)

    this.$nextTick(function () {
      var sb = this.$refs.simplebar
      if (!sb || !sb.scrollElement) return

      if (this.trackScroll) {
        sb.scrollElement.addEventListener('scroll', this.onScrollBound, { passive: true })
      }

      if (this.initialScroll) {
        sb.scrollElement.scrollTop = this.initialScroll
      }

      this.onScroll()
    }.bind(this))

    if (this.eventName) {
      this.$pubsub.$on(this.eventName + '.scrolltop', this.onScrollTopBound)
    }
  },

  beforeDestroy: function () {
    var sb = this.$refs.simplebar

    if (this.trackScroll && sb && sb.scrollElement && this.onScrollBound) {
      sb.scrollElement.removeEventListener('scroll', this.onScrollBound)
    }

    if (this.eventName && this.onScrollTopBound) {
      this.$pubsub.$off(this.eventName + '.scrolltop', this.onScrollTopBound)
    }
  },

  methods: {
    onScroll: function () {
      var sb = this.$refs.simplebar
      if (!sb || !sb.scrollElement || !sb.contentElement) return

      var contentHeight = sb.contentElement.offsetHeight
      var scrollHeight = sb.scrollElement.offsetHeight
      var scrollPositionY = sb.scrollElement.scrollTop
      var scrollPositionX = sb.scrollElement.scrollLeft

      this.$emit('scroll', { x: scrollPositionX, y: scrollPositionY })

      var offset = this.scrollendOffset || 0
      if (scrollPositionY + scrollHeight >= contentHeight - offset) this.$emit('scrollend')
    },

    onScrollTop: function () {
      var sb = this.$refs.simplebar
      if (sb && sb.scrollElement) sb.scrollElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>

</style>
